import { ECOM_VERSION } from './version';

export const environment = {
  production: true,
  version: ECOM_VERSION,
  apiHost: 'https://apibeta.ecus.se/',
  statNrApiHost: 'https://apibeta.ecus.se/',
  windowProxy: 'https://apibeta.ecus.se/proxy',
  windowOrigin: 'https://ecombeta.ecus.se',
  signalR: {
    url: 'https://apibeta.ecus.se/ecom'
  },
  timezone: 'Europe/Stockholm',
  defaultDateMoment: 'yyyy-MM-dd HH:mm',
  onlyDateMoment: 'yyyy-MM-dd',
  maxFileSize: 20971520, // 20 MiB
  sentry: {
    dsn:
      'https://942b76b925724465b124a4d82b01a595@o509176.ingest.sentry.io/5753892',
    environment: 'beta',
    tracingOrigins: ['apibeta.ecus.se'],
    tracesSampleRate: 0.2
  },
  auth: {
    clientId: 'b870972c-399b-4cdb-a48b-6d9cbe5edd4f',
    authority: 'https://login.microsoftonline.com/763b455e-7bef-4e0f-9270-b65a6b067764',
    redirectUri: 'https://ecombeta.ecus.se',
    scopes: ['user.read', 'api://EcomApi/Ecom.Api']
  }
};
